import React, { useContext } from 'react';
import { CurrentCaseContext } from './CurrentCaseContext';
import { useCurrentCase } from 'hooks/useCurrentCase';
import { CurrentCaseIdContext } from './CurrentCaseIdContext';

export type CurrentCaseContextValue = ReturnType<typeof useCurrentCase>;

export const CurrentCaseProvider = ({ children }: { children: React.ReactNode }) => {
  const currentCaseData = useCurrentCase();

  return (
    <CurrentCaseContext.Provider value={currentCaseData}>
      <CurrentCaseIdContext.Provider value={currentCaseData.currentCaseId}>
        {children}
      </CurrentCaseIdContext.Provider>
    </CurrentCaseContext.Provider>
  );
};

export const useCurrentCaseContext = (): CurrentCaseContextValue => {
  const context = useContext(CurrentCaseContext);

  if (!context) {
    throw new Error('useCurrentCaseContext must be used within a CurrentCaseProvider');
  }

  return context;
};
